import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class IsBusinessDayClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(date: IJsonDate): Promise<boolean, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Common/IsBusinessDay/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { date: date }

    return AjaxWrapper.get<boolean, any>(url, data);
  }
}

